import React, {useState} from "react";
import MangeDashboard from "./MangeDashboard";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import Toast from "./Tost";
import './CartEhraz.css'
import { ToastContainer, toast } from 'react-toastify';
import Resizer from "react-image-file-resizer";

axios.defaults.withCredentials = true;

export function CartEhraz() {
        const [error,seterror] =useState({codeMeli:'', cartNumbrr:'',shebaNumber:'',flag:true})
        const [cart,setcart] = useState('')
        const [cartNumbrr,setcartNumbrr] = useState('')
        const [shebaNumber,setshebaNumber] = useState('')
        const [cartUrl,setcartUrl] = useState('')
        const [flag,setflag] = useState(true) 
        const [token,settoken] = useState('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjQ1NTI5MTgwLCJpYXQiOjE2NDU1Mjg4ODAsImp0aSI6ImYxNTk5NzZiMjMxMDQ5N2NiM2U0NzM4N2M2NDRhYTRmIiwidXNlcl9pZCI6MSwicGhvbmUiOiIwOTM4Mzg3OTUxOCIsInBhc3N3b3JkIjoicGJrZGYyX3NoYTI1NiQyNjAwMDAkVVlOeFcwM3BNM2o1MGl6YUNNOWtHSyRiNXJZUWJMbHkybGZwVno3YnZMSXRUdHRkWFF1N2V5MW9RSHZYZTZBSTZZPSJ9.Kg6XzgQCSbUILnaiVjctOoctHnGjF_gtOEKVSVbAqyQ')
        const [message,setmessage] = useState('')
        const [type,settype] = useState('')
        const navigate = useNavigate();
        const[isLoading,setIsLoading] = useState(false)

        const resizeFile = (file) => new Promise(resolve => {
            Resizer.imageFileResizer(file, 1200, 1200, 'JPEG', 100, 0,
            uri => {
              resolve(uri);
            }, 'file' );
            });
        



        var IsDigit = new RegExp(/^[0-9]/);
        var IsSheba = new RegExp(/^IR[0-9]/)






      async function handleChange(event) {
        if((event.target.name == 'profile' || event.target.name == 'meli' || event.target.name == 'cart') && event.target.files[0] ) {


            let file =  event.target.files[0]
            if (file.size > 10240000){
                toast.dismiss()
                toast.error("حداکثر سایز فایل انتخابی  ده مگابایت است ")
                return
            }
        }
           if (event.target.name == 'cart' && event.target.files[0]) {
               setcartUrl(URL.createObjectURL(event.target.files[0]));
               const image = await resizeFile(event.target.files[0]);

               setcart(image)

           } else if (event.target.name == 'cartNumber') {
               let targetvalue = event.target.value
               if (IsDigit.test(targetvalue)) {
                   if (targetvalue.length == 16) {
                       seterror({...error, cartNumbrr: ''})
                       setcartNumbrr(targetvalue)
                       setflag(false)
                   } else {
                       seterror({...error, cartNumbrr: 'شماره کارت خود را به درستی وارد نمایید'})
                       setflag(true)

                   }
               } else {
                   seterror({...error, cartNumbrr: 'شماره کارت خود را به درستی وارد نمایید'})
                   setflag(true)
               }
           } else if (event.target.name == 'shebaNumber') {
               let targetvalue = event.target.value
               targetvalue =  `IR${targetvalue}`

               if (IsSheba.test(targetvalue) && targetvalue.length == 26) {
                   seterror({...error, shebaNumber: ''})
                   setshebaNumber(targetvalue)
                   setflag(false)


               } else {
                   seterror({...error, shebaNumber: 'شماره شبا خود را به درستی وارد نمایید'})
                   setflag(false)

               }
           }
       }





       function handelSubmit(event){
        event.preventDefault()
        const  formdata = new FormData();
        if(!cart  || !cartNumbrr || !shebaNumber)
        {
            toast.dismiss()
            toast.error('لطفا اطلاعات کارت را کامل وارد نمایید')
            return
        }
        const id = toast.loading("درحال بارگذاری اطلاعات شما...")

        setIsLoading(true)
        if(sessionStorage.getItem('user')){
            var phone = sessionStorage.getItem('user')
            settoken(localStorage.getItem('TOKEN'))
        }

        console.log(phone)
        formdata.append('phone',phone)
        formdata.append('cart',cart)
        formdata.append('cartNumbrr',cartNumbrr)
        formdata.append('shebaNumber',shebaNumber)





        axios.post('https://api.sinatether.com/Auth/CartEhraz/',formdata,{
           withCredentials:true,},).then((response) =>{
            console.log(response)
            if (response.status == 200){
                if (response.data['status'] == 200)
                {
                    toast.update(id, { render: "اطلاعات به درستی ارسال شد", type: "success", isLoading: false });

                    navigate('/Ehrazwaiting')
                    
                }else if (response.data['status'] == 201)
                {
                    toast.dismiss()
                   toast.error('کارت بانکی شما قبلا احراز شده است ')

                }
                else if (response.data['status'] == 202)
                {
                    toast.dismiss()
                    toast.error('کارت بانکی شما در انتظار تایید احراز  است ')


                }
                setIsLoading(false)



            }

                
               
                

        }

        ).catch(error =>{
            if (error)
            {
                console.log(error.response.status)
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                }else{
                toast.dismiss()
                toast.error('اطلاعات به درستی ارسال نشد دوباره امتحان کنید')
                setIsLoading(false)
                }


            }

            }
        )
  }






    return(
        <MangeDashboard>
            <Toast type={type} message={message}/>


            <div className="verification  align-items-center  mt-5 pt-5">
                <div className="container align-items-center setStyleSlider ">
                <div className="identity-content pcss34242 text-center">
                                            <img src="./images/shield.svg" alt=""/>
                                            <h6 className={'text-normal just-center pt-2'}> برای احراز کارت باید تمام فیلدها را پرکنید </h6>
                                         </div>
                            <form onSubmit={handelSubmit} className={'align-items-center '} id={'bform'}>
                                <div className={'form-group'}>


                                                 </div>
                                                    <div className={'form-group'}>
                                                    <input type="text" name={'cartNumber'} className="form-control input-ehraz" placeholder={'شماره کارت'}   onChange={handleChange} required />

                                                        <div className={'text-danger'}>
                                                           {error.cartNumbrr}
                                                       </div>

                                                    </div>



                                                     <div className={'form-group'}>
                                                     <div className={'row'}>
                                                             <div className={'col-10 pl-2 pr-0'}>
                                                             <input type="text" name={'shebaNumber'} className="form-control pr-0 pl-2 input-ehraz fdkkfdmfgkd" placeholder={'شماره شبا بدون IR'}   onChange={handleChange} required/>


                                                             </div>
                                                             <div className={'col-2 tex-center pl-0 '}>
                                                             <input type={'text'} className="form-control KSJDHSG545335 input-ehraz" value={'IR'} readOnly={true}/>
                                                             </div>

                                                         </div>
                                                          <div className={'text-danger'}>
                                                           {error.shebaNumber}
                                                          </div>

                                                     </div>

                                            <div className="form-group">
                                            <div className="file-upload-wrapper" data-text="عکس کارت بانکی">
                                                <input name={'cart'} type="file"
                                                       className="form-control" onChange={handleChange} required/>

                                            </div>
                                                <span className="float-right text-medium text-warning pl-2"> حداکثر انداز10 مگابایت است</span>
                                                 <div className={'text-left'}>
                                                {cartUrl ? <img data-display-toggle={cartUrl} src={cartUrl} id={'imgcart'} className=" rounded mt-2 ml-2" alt={''} onError={"this.style.display='none'"}  /> : <img src={""}/> }
                                                </div>

                                             </div>


                                                 <div className={'text-center align-items-center pb-3'}>
                                    <button disabled={flag} className={'btn btn-sehraz'}>


                                    {isLoading ? 
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                    :

                                                 <span>ارسال</span>
                                                }

                                    </button>

                                </div>


            </form>

            </div>


            </div>

        </MangeDashboard>
    )

}